import {Subject} from 'rxjs';

export class AppLoadingEventsEmitter {
    private readonly appIsLoading: Subject<boolean> = new Subject();
    private isLoading = false;
    private isDisable = false;

    appIsLoading$ = this.appIsLoading.asObservable();


    broadcastAppIsLoading(loading: boolean) {
        if (this.isDisable === true) {
            return;
        }

        this.isLoading = loading;
        this.appIsLoading.next(loading);
    }

    changeIsDisable(isDisable: boolean) {
        this.isDisable = isDisable;
    }

    isAppLoading() {
        return this.isLoading;
    }
}
